import { http } from "../api/http";
import Utils from "../utils";

export const permissionGroupService = {
  getAll,
  getById,
  create,
  update,
  remove,
};

async function getAll(requestParameters = {}) {
  let url = "/permissiongroup";

  if (Object.keys(requestParameters).length > 0) {
    url += `?${Utils.objectToQueryString(requestParameters)}`;
  }

  return await http.get(url).then((response) => {
    return response;
  }).catch((error) => {
    throw error;
  });
}

async function getById(groupId) {
  let url = `/permissiongroup/${groupId}`;
  return await http.get(url).then((response) => {
    return response;
  }).catch((error) => {
    throw error;
  });
}

async function create(data) {
  let url = "/permissiongroup";
  return await http.post(url, data).then((response) => {
    return response;
  }).catch((error) => {
    throw error;
  });
}

async function update(data) {
  let url = "/permissiongroup";
  return await http.put(url, data).then((response) => {
    return response;
  }).catch((error) => {
    throw error;
  });
}

async function remove(groupId) {
  let url = `/permissiongroup/${groupId}`;
  return await http.delete(url).then((response) => {
    return response;
  }).catch((error) => {
    throw error;
  });
}
